import { Env } from '@stencil/core';
let analyticsService = null;
import { scrollToTop } from '../../../../../common/hair-quiz-vto/utils/utils';

export const getVtoStateObject = async () => {
  const handlers = window?.['AIBA']['utils'];
  const vtoState = await handlers.getVtoState();
  return vtoState;
};

export const vtoCameraDidLoad = () => {
  let startTime;
  function vtoHintBlock(timestamp) {
    const vtoHintContainer = document.querySelector('aiba-app').shadowRoot.querySelector('.vtoHintContainer');
    if (vtoHintContainer) {
      vtoHintContainer['style']['display'] = 'none';
    }
    if (!startTime) {
      startTime = timestamp;
    }
    const elapsedTime = timestamp - startTime;
    if (elapsedTime < 1000) {
      requestAnimationFrame(vtoHintBlock);
    }
  }
  requestAnimationFrame(vtoHintBlock);
};

export const getRecommendedStyle = async () => {
  const handlers = window?.['AIBA']['utils'];
  const recommendedStyles = await handlers.getRecommendedStyles();

  return recommendedStyles;
};

export const getKeepPhotoState = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window?.['AIBA']['utils'];
    analyticsService = handlers.analyticsService;

    return await handlers.getKeepPhoto();
  }
};

export const showErrorScreen = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window?.['AIBA']['utils'];
    await handlers.setShowErrorScreen(true);
  }
}

export const vtoScreenInit = async () => {
  if (!document.getElementById('YMK-module')) {
    const div = document.createElement('div');
    div.id = 'YMK-module';
    document.getElementsByTagName('aiba-app')[0].parentElement.insertBefore(div, document.getElementsByTagName('aiba-app')[0]);
    // document.getElementById('YMK-module').style.height = '500px';
    document.getElementById('YMK-module').style.background = '#000';
    document.getElementById('YMK-module').style.justifyContent = 'center';
    const item = document.getElementById('YMK-module');
    item.style.display = 'flex';
    if (window['AIBA'] && window['AIBA']['utils']) {
      const handlers = window?.['AIBA']['utils'];
      const showResultScreen = await handlers.getShowResultScreen();
      const hideVTOScreen = await handlers.getHideVTOScreen();
      if (showResultScreen || hideVTOScreen) {
        item.style.display = 'none';
      }
    }
  } else {
    // const handlers = window?.['AIBA']['utils'];
    // const item = document.getElementById('YMK-module');
    // if (await handlers.getShowResultPage()) {
    //   item.style.display = 'none';
    // } else {
    //   item.style.display = 'flex';
    // }
  }
};

export const handleNavigationBlockButtonClick = async (event: Event) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;
    event.target['href'] = 'vto welcome screen';
    await analyticsService?.registerEvent('event2', event);

    document.getElementById('YMK-module')?.parentNode?.removeChild(document?.getElementById('YMK-module'));
    await handlers.setRecommendedStyles('');
    return await handlers.initState();
  }
};
export const navigationBlockOnLoad = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const currentScreen = await handlers.getVtoState().currentJourney;
    if (currentScreen == 'vto_screen') {
      analyticsService = handlers.analyticsService;
      await analyticsService?.registerEvent('event1', { page: 'Aiba Analysis Failed screen' });
    }
  }
};

export const getVtoConfig = async () => {
  const handlers = window['AIBA']['utils'];
  const config = await handlers.getConfig();
  return config.vtoConfig;
};

export const vtoReadyHandler = () => {
  window.dispatchEvent(new CustomEvent('vtoReadyToGenerate'))
}

export const vtoPreLoad = async () => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;
  const data = await handlers.getShowResultPage();
  await handlers.setShowResultPage(false);
  await handlers.setKeepPhoto(false);
  handlers.scrollToTop = true;
  console.info(`[vtoPreLoad data]`, data);
  await handlers?.setStyle({
    activeTab: '',
    selectedStyleId: '',
    trackstyles: [],
    selectedStyleTab: '',
  });
  await handlers?.setStyleData({ foundId: '', index: '', id: '' });
};

export const setVtoRenderBlock = (blockname = 'YMK-module') => {
  if (!document.getElementById(blockname)) {
    const div = document.createElement('div');
    div.id = blockname;
    document.body.appendChild(div);
    // document.getElementById(blockname).style.height = '500px';
    document.getElementById(blockname).style.display = 'flex';
  }
};

export const initateVto = async () => {
  // Need to access ENV uncomment the env import
  return {
    VTO_SDK_SDK_PATH: Env.VTO_SDK_SDK_PATH,
    VTO_SDK_API_KEY: Env.VTO_SDK_API_KEY,
    ID: 'initscript',
  };
};

export const clickHandler = async style => {
  const iframeWindow = document.querySelector('aiba-app').shadowRoot.getElementById('vtoFrame')['contentWindow'];
  iframeWindow['YMK'].generateStyle(style);
};

export const getVtoEventObj = (label: string, destinationurl: string) => {
  const event = {
    e: 'targetElement',
    textContent: label,
    href: destinationurl,
  };
  return event;
};

export const setVtoEventLoaded = async () => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;
  scrollToTop();
  analyticsService && analyticsService.registerEvent('event1', { page: 'vto camera selfie capture screen' });
  vtoResizeWindowOuter();
};

export const setVtoEventCameraClosed = async () => {
  vtoResizeWindowOuter();
};

export const setVtoEventEngineOpened = async () => {
  const handlers = window['AIBA']['utils'];
  vtoResizeWindowOuter();
  if (handlers.scrollToTop === true) {
    scrollToTop();
  }
  handlers.scrollToTop = false;
};

export const setVtoEventLiveCamIconClicked = async () => {
  vtoResizeWindowOuter();
};

export const setVtoEventLauncherPageEntered = async () => {
  const handlers = window['AIBA']['utils'];
  await handlers.setKeepPhoto(false);
  //   document.getElementById('YMK-module-iframe').style.height = '500px';
  document.getElementById('YMK-module-iframe').title = 'virtual try on screen inner container';
  await handlers.setShowErrorScreen(false);
  //   document.getElementById('YMK-module').style.height = '500px';
  //   document.getElementById('YMK-module-iframe')['contentWindow'].window.document.querySelectorAll('[role="document"]')[0].style.height = '500px';
  //   document.getElementById('YMK-module-iframe')['contentWindow'].window.document.querySelectorAll('[role="document"]')[0].parentNode.style.height = '500px';
  // const isScroll = window?.scrollY || scrollY;
  // if (isScroll) {
  //   scrollToTop();
  // }
  // await scrollToTop();
};

export const setVtoEventHairStyleChanged = async report => {
  document.querySelector('aiba-app').shadowRoot.getElementById('vtooverlay') && (document.querySelector('aiba-app').shadowRoot.getElementById('vtooverlay').style.display = 'none');
  console.log(report);
};

export const setVtoEventBackIconClicked = async report => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;
  await handlers.setKeepPhoto(false);
  await handlers.setStyle({
    activeTab: '',
    selectedStyleId: '',
    trackstyles: [],
    selectedStyleTab: '',
  });

  analyticsService && analyticsService.registerEvent('event2', getVtoEventObj('backIconClicked', 'vto camera selfie capture screen'));
  analyticsService && analyticsService.registerEvent('event1', { page: 'vto camera selfie capture screen' });
  console.log(report);
};

export const setVtoEventReadyButtonClicked = async report => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers?.analyticsService;
    const vtoHintContainer = document.querySelector('aiba-app').shadowRoot.querySelector('.vtoHintContainer');

    vtoHintContainer['style']['display'] = 'flex';
    analyticsService.registerEvent('event2', getVtoEventObj("I'm Ready", 'vto camera selfie capture screen'));
    vtoResizeWindowOuter();
    console.log(report);
  }
};

export const setVtoEventCloseIconClicked = async report => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;

  analyticsService && analyticsService.registerEvent('event2', getVtoEventObj('closeIconClicked', 'vto camera selfie capture screen'));
  console.log(report);
};

export const setVtoEventFlipCamera = async report => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;

  analyticsService && analyticsService.registerEvent('event2', getVtoEventObj('flipCamera', 'vto camera selfie capture screen'));
  console.log(report);
};

export const setVtoEventRetakePhoto = async report => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;

  analyticsService && analyticsService.registerEvent('event2', getVtoEventObj('retakePhoto', 'vto camera selfie capture screen'));
  analyticsService && analyticsService.registerEvent('event1', { page: 'vto camera selfie capture screen' });
  console.log(report);
};

export const setVtoEventKeepPhoto = async report => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers?.analyticsService;
    await handlers.setKeepPhoto(true);
    await analyticsService.registerEvent('event2', getVtoEventObj('keepPhoto', 'vto recommended style screen'));
    const customResultsEvent = {};
    customResultsEvent['data'] = [];
    customResultsEvent['label'] = 'AIBA - Beauty Advisor completed';
    customResultsEvent['component'] = 'Beauty Advisor';

    let quizInfo: string = '';
    const retake = await handlers.getStateRetakeJourney();
    quizInfo = `hair analysis - ${retake ? 'retake' : 'take'} quiz`;
    customResultsEvent['data']['quizInfo'] = quizInfo;
    await analyticsService.registerEvent('event25', customResultsEvent);

    console.log(report);
  }
};

export const setVtoEventConfirmExit = async report => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;
  await handlers.setKeepPhoto(false);
  await handlers?.setStyle({
    activeTab: '',
    selectedStyleId: '',
    trackstyles: [],
    selectedStyleTab: '',
  });
  analyticsService && analyticsService.registerEvent('event2', getVtoEventObj('confirmExit', 'vto selfie wrapper screen'));
  console.log(report);
};

export const activeTabhandler = async event => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;

  analyticsService && analyticsService.registerEvent('event2', getVtoEventObj(`${event.target.textContent}`, 'vto recommended style screen'));
};

export const setVtoEventPhotoSaved = async () => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;

  analyticsService && analyticsService.registerEvent('event2', getVtoEventObj('photoSaved', 'vto photo saved screen'));
};

export const setVtoEventCancelExit = async report => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;

  console.log(report);
  analyticsService && analyticsService.registerEvent('event2', getVtoEventObj('cancelExit', 'vto selfie wrapper screen'));
};

export const setVtoEventInaccessibleCameraGotIt = async report => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;

  analyticsService && analyticsService.registerEvent('event2', getVtoEventObj('inaccessibleCameraGotIt', 'vto selfie wrapper screen'));
  console.log(report);
};

export const setVtoEventPhotoCaptured = async report => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;

  analyticsService && analyticsService.registerEvent('event2', getVtoEventObj('photoCaptured', 'vto photo Captured screen'));
  analyticsService && analyticsService.registerEvent('event1', { page: 'vto photo Captured screen' });
  console.log(report);
};

export const vtoCloseYMKModule = () => {
  const iframeWindow = document.querySelector('aiba-app').shadowRoot.getElementById('vtoFrame')['contentWindow'];
  iframeWindow['YMK'].close();
};

export const vtoCloseModel = async () => {
  (document.querySelector('aiba-app').shadowRoot.querySelectorAll('.model')[0] as any).style.display = 'none';
};

export const vtoResizeWindowOuter = async () => {
  //   const handlers = window['AIBA']['utils'];

  const handlers = window['AIBA']['utils'];
  const showResultScreen = await handlers.getShowResultScreen();
  const hideVTOScreen = await handlers.getHideVTOScreen();
  if (showResultScreen || hideVTOScreen) {
    if (document.getElementById('YMK-module')) document.getElementById('YMK-module').style.display = 'none';
  } else {
    if (document.getElementById('YMK-module')) document.getElementById('YMK-module').style.display = 'block';
  }
  //   if (await handlers.getShowResultPage()) {
  //     document.getElementById('YMK-module').style.display = 'none';
  //   } else {
  //     document.getElementById('YMK-module').style.display = 'block';
  //   }
};

export const setVtoEventUploadPhotoIconClicked = async () => {};

export const setVtoEventChooseModelIconClicked = async () => {};

export const setVtoEventCameraFailed = async () => {};

export const setVtoEventCameraOpened = async () => {};

export const setVtoEventClosed = async () => {
  const handlers = window?.['AIBA']['utils'];
  const vtoHintContainer = document.querySelector('aiba-app').shadowRoot.querySelector('.vtoHintContainer');
  if (vtoHintContainer && vtoHintContainer['style']) {
    vtoHintContainer['style']['display'] = 'none';
  }
  handlers.scrollToTop = true;
  await handlers.setKeepPhoto(false);
};

export const setVtoEventEngineClosed = async () => {};

export const setVtoEventConsentUIShowed = async () => {};

export const setVtoEventDisagreeUIShowed = async () => {};

export const setVtoEventConsentUpdated = async () => {};

export const getVtoReccomendations = async (event) => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;

  const data = {
    recommendedStyles: await handlers.getRecommendedStyles(),
    style: await handlers.getStyle(),
    recommendedProducts: await handlers.getRecommendedProducts(),
  };

  event.target.href = data?.style?.selectedStyle;
  analyticsService && analyticsService.registerEvent('event2', event);
  data.recommendedStyles[0][data.style.selectedStyleTab].forEach(style => {
    if (style.id === data.style.selectedStyleId) {
      data.recommendedProducts = [...style.products];
    }
  });
  await handlers.setShowResultPage(true);
  await handlers.setShowResultScreen(true);
  await handlers.setRecommendedProducts(data.recommendedProducts);
  //   document.getElementById('YMK-module').parentNode.removeChild(document.getElementById('YMK-module'));
  // document.getElementById('YMK-module').parentNode.childNodes[3]['style'].display = 'none';
  document.getElementById('YMK-module').style.display = 'none';
  //   await handlers.getNextJourney('vto_screen');
  //state.atUserJourney = UserJourney.SKIN_RECOMMENDATIONS;
};

export const setVtoHairStyle = async (hairstyle, event, id, tab, target) => {
  const buttonCliked = event.target;
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;

  const data = await handlers.getStyle();
  target
    .querySelector('.tabcontainer')
    .querySelectorAll('.styles')
    .forEach(element => {
      element.classList.remove('activestyle');
    });
  if (buttonCliked) {
    if (buttonCliked.tagName.toLowerCase() === 'img') {
      buttonCliked.parentElement.classList.add('activestyle');
    } else {
      buttonCliked.classList.add('activestyle');
    }
  }
  const allStyles = await handlers.getRecommendedStyles();
  const firstStyleId = allStyles[0]['recommendation'][1]['id'];

  const index = data.trackstyles.findIndex(entry => entry === id);
  if (index != -1) {
    handlers?.setStyleData({ foundId: true, index: index + 1, id: id });
  }

  if (data.selectedStyleId !== id || firstStyleId === id) {
    //target.style.display ='block';

    data.selectedStyleId = id;
    data.selectedStyle = hairstyle;
    data.selectedStyleTab = tab;

    const originalStyle = 'original';

    if (!data?.trackstyles.includes(id) && id != originalStyle) {
      data.trackstyles.push(id);
    }

    await handlers.setStyle(data);
    if (firstStyleId === id) {
      await vtoYMKsetStyle(hairstyle, 'original', target);
      await vtoYMKsetStyle(hairstyle, id, target);
    } else {
      await vtoYMKsetStyle(hairstyle, id, target);
    }
  }

  // analyticsService &&
  //   analyticsService?.registerEvent('event2', {target: { eventTitle: `style selected - ${hairstyle}` },});
  const tabs = document.querySelector('aiba-app').shadowRoot?.querySelectorAll('.tab-container__tabs .tab') as any;
  tabs.forEach(tab => {
    tab.addEventListener('keypress', e => {
      if (e.key === 'Enter') {
        e.target.click();
      }
    });
  });
};

export const vtoYMKsetStyle = async (hairstyle, id, target) => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;

  if (window?.['YMK']?.isLoaded()) {
    target.querySelector('#vtooverlay').style.display = 'block';
    const styleName = hairstyle;
    setTimeout(async () => {
      target.querySelector('#vtooverlay').style.display = 'block';
      try {
      if (id === 'original') {
        await window['YMK'].reset();
        document.querySelector('aiba-app').shadowRoot.getElementById('vtooverlay') &&
          (document.querySelector('aiba-app').shadowRoot.getElementById('vtooverlay').style.display = 'none');
      } else {
        const styleExist = await handlers?.getStyleData();
        const customVtoStylesEvent = { data: {} };
        customVtoStylesEvent['data']['styleName'] = styleName;
        if (styleExist?.foundId) {
          await window['YMK']?.applyStyle(styleExist?.index);
          customVtoStylesEvent['data']['type'] = 'reapplied'; // first-time/reapplied
          await analyticsService?.registerEvent('eventVto', customVtoStylesEvent);
          document.querySelector('aiba-app').shadowRoot.getElementById('vtooverlay') &&
            (document.querySelector('aiba-app').shadowRoot.getElementById('vtooverlay').style.display = 'none');
          handlers?.setStyleData({ foundId: '', index: '', id: '' });
        } else {
          await window['YMK'].generateStyle(id);
          customVtoStylesEvent['data']['type'] = 'first-time'; // first-time/reapplied
          await analyticsService?.registerEvent('eventVto', customVtoStylesEvent);
        }
      }
    } catch (error) {
      console.error('Error in vtoYMKsetStyle:', error);
    }
    }, 1000);
    return true;
  } else {
    console.log('photo not loaded yet');
    return false;
  }
};

const getAbsolutePath = () => {
  let path = Env.BASE_URL ? Env.BASE_URL : '';
  if (!(Env.BASE_URL.split('localhost').length > 1)) {
    path += Env.FEATURE_PATH ? '/' + Env.FEATURE_PATH : '';
    path += Env.BRAND ? '/' + Env.BRAND : '';
    path += Env.LOCALE ? '/' + Env.LOCALE : '';
    let version = Env.VERSION ? '/' + Env.VERSION : '';
    path += Env.JOURNEY ? '/' + (Env.JOURNEY.split('-')[0] === 'hair' ? 'vto/' + version : 'vto/' + version) : '';
  }
  return path;
};

export const viewMoreClickHandler = () => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;

  analyticsService && analyticsService.registerEvent('event2', getVtoEventObj('View more', null));
};

export const getVtoStyleStateData = async () => {
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers?.analyticsService;

  await analyticsService.registerEvent('event1', { page: 'vto recommended style screen' });

  // analyticsService?.registerEvent('event2', { target: { textContent: 'Style picks for you', href: 'vto recommended style screen' } });

  const data = {
    recommendedStyles: await handlers.getRecommendedStyles(),
  };
  const nostyle_asset_url = getAbsolutePath() + '/assets/static/nostyle.svg';
  if (data?.recommendedStyles?.length > 0) {
    const originalStyle = {
      id: 'original',
      style: 'No Style',
      styleimageurl: nostyle_asset_url,
      youtubevideo: '',
      shape: '',
      stylesq: '',
      ar: true,
      style_intro: '',
      products: [
        {
          identifierValue: '',
          productName: '',
          description: '',
          reviews: 0,
          pageUrl: '',
          imageUrl: '',
          smartProductId: '',
          shortDescription: '',
        },
      ],
    };

    const viewMore = {
      id: 'viewmore',
      style: 'View more',
      style_intro: 'View more',
      styleimageurl: getAbsolutePath() + '/assets/svg/viewmore.svg',
      youtubevideo: '',
      shape: '',
      stylesq: '',
      ar: true,
      products: [
        {
          identifierValue: '',
          productName: '',
          description: '',
          reviews: 0,
          pageUrl: '',
          imageUrl: '',
          smartProductId: '',
          shortDescription: '',
        },
      ],
    };

    if (data.recommendedStyles[0]['recommendation'].length > 0 && data.recommendedStyles[0]['recommendation'][0].id !== 'original') {
      data.recommendedStyles[0]['recommendation'] = [originalStyle, ...data.recommendedStyles[0]['recommendation']];
    }

    if (
      data.recommendedStyles[0]['recommendation'].length > 0 &&
      data.recommendedStyles[0]['recommendation'][data.recommendedStyles[0]['recommendation'].length - 1].id !== 'viewmore'
    ) {
      data.recommendedStyles[0]['recommendation'] = [...data.recommendedStyles[0]['recommendation'], viewMore];
    }
    // Tab to render first is based on styleTitle order

    return {
      recommendedStyles: data?.recommendedStyles[0],
      styleTitle: { recommendation: 'Style picks for you', other: 'More style inspo' },
      styleContent: {
        HAIR_STYLE_01_82: 'Loose Waves',
        HAIR_STYLE_01_98: 'Voluminous Glam Hollywood Waves',
        HAIR_STYLE_01_81: 'Curly Bangs',
        HAIR_STYLE_01_80: 'Short Curls',
        HAIR_STYLE_01_65: 'Side swept Curls',
        HAIR_STYLE_01_05: 'Curtain Bangs',
        HAIR_STYLE_01_100: 'Round Blush Blowout',
        HAIR_STYLE_01_91: 'Slicked back bun',
        HAIR_STYLE_01_90: 'Sleek bob',
        HAIR_STYLE_01_99: 'Mermaid Waves',
        HAIR_STYLE_01_88: 'Beachy Waves',
        HAIR_STYLE_01_87: 'Wavy Lob',
        HAIR_STYLE_01_06: 'Voluminous Curls',
        HAIR_STYLE_01_85: 'Blunt Wavy Bob',
        HAIR_STYLE_01_92: 'Blunt Straight Bob',
        HAIR_STYLE_01_79: 'Brushed Back pixi',
        HAIR_STYLE_01_83: 'Pixi cut',
        HAIR_STYLE_01_89: 'Space buns',
        HAIR_STYLE_01_84: 'Fishtail Braid',
        HAIR_STYLE_01_101: 'Bubble Braids',
        HAIR_STYLE_01_86: 'French Braids',
        original: 'No style',
        viewmore: 'View more',
      },
    };
  } else {
    console.log('[getVtoStyleStateData]', 'recommendedStyles state object not available ');
  }
};

// export const componentWillLoadVtoHint = async data => {
//   let elements = data.elements.map(element => {
//     element.data.src = 'https://aiba-uat.unileversolutions.com/tresemme/en-us/v1/assets/static/hintImageTwo.png';
//     return element;
//   });
//   data = { elements: elements };
//   return data;
// };
